import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Wrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.greys[800]};
`

export const IconSlot = styled('span')<{ theme?: TTheme }>`
    display: inline-flex;
    align-items: center;
    color: ${({ theme }) => theme.colors.greys[800]};

    svg {
        width: 18px;
        height: auto;
    }
`
